import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Dashboard pages
import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue'
import Stats from 'src/components/Dashboard/Views/Dashboard/Stats.vue'
import PpesRequests from 'src/components/Dashboard/Views/Dashboard/PpesRequests.vue'
// used
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import ThankYou from 'src/components/Dashboard/Views/Pages/ThankYou.vue'
import Home from 'src/components/Dashboard/Views/Pages/Home.vue'
import ConfirmPassword from 'src/components/Dashboard/Views/Pages/ConfirmPassword.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import Confirm from 'src/components/Dashboard/Views/Pages/Confirm.vue'
import Reviews from 'src/components/Dashboard/Views/Dashboard/Reviews.vue'
import Profile from 'src/components/Dashboard/Views/Dashboard/Profile.vue'


import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'

import cognitoAuth from '@/cognito'

// import { CognitoUserPool, CognitoUserAttribute, CognitoUser } from 'amazon-cognito-identity-js'

function requireAuth (to, from, next) {
  cognitoAuth.isAuthenticated((err, loggedIn) => {
    if (err) return next()
    if (!loggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  })
}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

let thankYouPage = {
  path: '/thank-you',
  name: 'ThankYou',
  component: ThankYou
}

let confirmPasswordPage = {
  path: '/confirm-password',
  name: 'Confirm Password',
  component: ConfirmPassword
}

let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}

let confirmPage = {
  path: '/confirm',
  name: 'Confirm',
  component: Confirm
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  loginPage,
  confirmPasswordPage,
  registerPage,
  confirmPage,
  thankYouPage,
  lockPage,
  {
    path: '/admin2',
    component: DashboardLayout,
    redirect: '/admin/profile',
    children: [
      {
        path: 'reviews',
        name: 'Video Reviews',
        component: Reviews,
        beforeEnter: requireAuth
      },
      {
        path: 'profile',
        name: 'My Account',
        component: Profile,
        beforeEnter: requireAuth
      }
    ]
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/ppes-requests',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview,
        beforeEnter: requireAuth
      },
      {
        path: 'stats',
        name: 'Stats',
        component: Stats,
        beforeEnter: requireAuth

      },
      {
        path: 'ppes-requests',
        name: 'PpesRequests',
        component: PpesRequests,
        beforeEnter: requireAuth
      }
    ]
  },
  {path: '*', component: NotFound}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js